import { Skeleton } from '@voll-intelligence/ui-kit/ui/skeleton';

/**
 * O esqueleto do detalhe do hotel — as peças que a gaveta, a folha do celular e
 * a página larga montam enquanto o hotel carrega. Só forma, nenhum dado: a
 * anatomia espelha o estado pronto pra transição não deslocar (#2668).
 */

export function HotelDetailsSkeletonAmenities() {
  return (
    <div className="hui-hotel-details-skeleton-section">
      <Skeleton className="hui-hotel-details-skeleton-heading" />
      <div className="hui-hotel-details-skeleton-amenities">
        {Array.from({ length: 6 }, (_, index) => (
          <div key={index} className="hui-hotel-details-skeleton-amenity">
            <Skeleton className="hui-hotel-details-skeleton-amenity-icon" />
            <Skeleton className="hui-hotel-details-skeleton-line" />
          </div>
        ))}
      </div>
    </div>
  );
}

/** `data-rooms-skeleton` é a âncora da Página do Hotel que abre JÁ nos quartos
 *  (`openAtRooms` no genui-kit): com o detalhe hidratando, a seção `#rooms`
 *  ainda não existe e a página se posiciona aqui, nunca no topo. */
export function HotelDetailsSkeletonRooms() {
  return (
    <div className="hui-hotel-details-skeleton-section" data-rooms-skeleton>
      <Skeleton className="hui-hotel-details-skeleton-heading" />
      {Array.from({ length: 2 }, (_, index) => (
        <div key={index} className="hui-hotel-details-skeleton-room">
          <Skeleton className="hui-hotel-details-skeleton-room-photo" />
          <Skeleton className="hui-hotel-details-skeleton-line" />
          <Skeleton className="hui-hotel-details-skeleton-line" data-short="true" />
        </div>
      ))}
    </div>
  );
}

/** A galeria em esqueleto (gaveta, folha e página): a grade das fotos DENTRO da
 *  `.hui-hotel-details-gallery`, como a galeria pronta, nunca direto no corpo.
 *  Não é cosmético: como item direto do grid do corpo, a grade só tem altura
 *  por `aspect-ratio` e a trilha dela resolvia a zero (Chromium e WebKit) — a
 *  grade pintava na altura da proporção, mas abas e comodidades subiam por
 *  cima dela (issue #3263). `align-self: start` não bastou; o embrulho basta. */
export function HotelDetailsSkeletonGallery() {
  return (
    <div className="hui-hotel-details-gallery" aria-hidden="true">
      <div className="hui-hotel-details-gallery-grid">
        {Array.from({ length: 3 }, (_, index) => (
          <Skeleton key={index} className="hui-hotel-details-skeleton-photo" />
        ))}
      </div>
    </div>
  );
}

/** O corpo em esqueleto da gaveta e da folha: galeria, abas, comodidades e
 *  quartos — a mesma anatomia do estado pronto, pra transição não deslocar. */
export function HotelDetailsSkeletonBody() {
  return (
    <>
      <HotelDetailsSkeletonGallery />
      <div className="hui-hotel-details-skeleton-tabs" aria-hidden="true">
        {Array.from({ length: 4 }, (_, index) => (
          <Skeleton key={index} className="hui-hotel-details-skeleton-tab" />
        ))}
      </div>
      <HotelDetailsSkeletonAmenities />
      <HotelDetailsSkeletonRooms />
    </>
  );
}
